export default __webpack_public_path__ + "static/media/juha.2496d443.jpg";